
<mat-paginator
  class="p-0 m-0"
  *ngIf="state.allItems.length > state.pageSize"
  (page)="handlePageEvent($event)"
  [length]="state.allItems.length"
  [pageSize]="state.pageSize"
  [disabled]="false"
  [showFirstLastButtons]="true"
  [pageSizeOptions]="[state.pageSize]"
  [hidePageSize]="false"
  [pageIndex]="state.pageIndex"
  aria-label="Select page"></mat-paginator>

<div *ngIf="!state.pageItems.length" class="alert">
  No items found.
</div>
<div class="table-responsive" *ngIf="state.pageItems.length">
  <table class="table" [ngClass]="options.tableNgClass">
    <thead style="position: sticky; top: 0">
    <tr>
      <th *ngFor="let h of renderColumnHeaders" [ngClass]="options.headingNgClass || getCellCssClass(h)">
        {{h}}
      </th>
    </tr>
    </thead>
    <tbody>
    <tr
      *ngFor="let item of state.pageItems; let index = index"
      [ngClass]="getRowCssClass(item, index)"
      (click)="rowClick.next({
        index: index,
        rowItem: item
      })"
    >
      <td
        *ngFor="let h of renderColumnKeys"
        class="align-middle {{options.cellNgClass || 'fw-light'}}"
        [ngClass]="getCellCssClass(h)"
        (click)="cellClick.next({
          index: index,
          rowItem: item,
          cellKey: h,
          cellItem: getCellValue(item, h)
        })"
      >
        <ng-container
          [ngTemplateOutlet]="getCellTemplateRef(h) || defaultCellTemplate"
          [ngTemplateOutletContext]="{
            index: index,
            rowItem: item,
            cellItem: getCellValue(item, h),
            cellKey: h
          }"
        >
        </ng-container>
      </td>
    </tr>
    </tbody>
  </table>
</div>
<mat-paginator *ngIf="state.allItems.length > state.pageSize"
               class="demo-paginator"
               (page)="handlePageEvent($event)"
               [length]="state.allItems.length"
               [pageSize]="state.pageSize"
               [disabled]="false"
               [showFirstLastButtons]="true"
               [pageSizeOptions]="[state.pageSize]"
               [hidePageSize]="false"
               [pageIndex]="state.pageIndex"
               aria-label="Select page">
</mat-paginator>

<ng-template
  #defaultCellTemplate
  let-index=index
  let-rowItem=rowItem
  let-cellKey=cellKey
  let-cellItem=cellItem
  let-type=type
>
  <ng-container [ngSwitch]="reflector.getReflectedType(cellItem)">
    <ng-container *ngSwitchCase="'string'">{{cellItem}}</ng-container>
    <ng-container *ngSwitchCase="'function'">Function</ng-container>
    <ng-container *ngSwitchCase="'number'">{{cellItem}}</ng-container>
    <ng-container *ngSwitchCase="'bigint'">{{cellItem}}</ng-container>
    <ng-container *ngSwitchCase="'boolean'">
      <span class="text-primary fw-light" [ngClass]="{'text-danger': !cellItem }">{{cellItem ? "Yes" : "No"}}</span>
    </ng-container>
    <ng-container *ngSwitchCase="'date'">{{cellItem | date}}</ng-container>
    <span *ngSwitchDefault>
      <span *ngIf="cellItem == null" class="text-primary fw-light">
        null
      </span>
      <span *ngIf="cellItem != null">
        {{cellItem | json}}
      </span>
    </span>
  </ng-container>
</ng-template>
